<script>
	import logo from '$lib/images/logo_symbol_wt.svg';
	//TODO: PHILIP REVIEW
	import settingIcon from '$lib/images/icon_settings.svg';
	import { PUBLIC_VERSION } from '$env/static/public';
  import { onMount } from 'svelte';
	import { Util } from '$lib/utils';
  export let theme = '';
  export let showSettings = false;

	let feedbackForm = 'https://trueself.typeform.com/betafeedback';

	onMount(()=>{
		let user = Util.getLoggedInUserInfo();
		if(user != null){
			feedbackForm = feedbackForm + `#email=${user.email}&name=${user.firstName}&user_id=${user._id}`;
		}
	})
</script>

<footer class={`flex relative text-[11px] px-5 items-center justify-center mb-1 gap-5 h-11 w-full ${theme === 'light' ? 'text-primary' : 'text-white'}`}>
	<div class="flex items-center justify-between w-full">
		<div class="flex items-center gap-2.5">
			<div class="flex">
				<svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3.22405 12.5652C1.95493 12.1047 0.922371 11.1556 0.35618 9.92901C0.35618 9.92901 -0.184402 8.65051 0.0663833 7.27607C0.317169 5.90163 1.29245 5.08499 1.86089 4.74361C2.854 4.15233 5.28495 2.68083 5.96709 2.15872C6.64923 1.63661 7.69472 0.728499 8.31556 0C9.14651 0.657938 9.63071 1.66051 9.62967 2.721C9.62967 3.46623 9.35994 4.27617 8.93528 4.78601C8.51061 5.29584 8.20521 5.66065 7.6245 6.09128C5.81216 7.43672 3.5406 8.47982 2.94317 9.02982C2.42701 9.49035 2.15787 10.1674 2.21687 10.857C2.27588 11.5466 2.65612 12.168 3.243 12.534" class={`${theme === 'light' ? 'fill-primary' : 'fill-white'}`}/>
					<path d="M3.26914 12.56C4.82309 10.6675 6.98786 9.36408 9.39841 8.86951C9.69975 9.18243 9.99997 9.88376 9.99997 10.6825C9.99997 11.4812 9.4536 12.165 8.91275 12.5786C8.32002 13.0305 7.40058 13.5633 6.63345 14.1716C5.86633 14.78 4.17203 16.3435 4.13119 16.9999C3.29343 16.4835 2.59253 15.4682 2.59253 14.4178C2.59208 13.7391 2.83016 13.0814 3.26583 12.5578" class={`${theme === 'light' ? 'fill-primary' : 'fill-white'}`}/>
					<path d="M6.29514 9.76959C5.13405 10.3942 4.10497 11.2167 3.25983 12.1956C2.67095 11.8482 2.28942 11.2584 2.23021 10.6038C2.17101 9.94931 2.44106 9.30664 2.95898 8.86951C3.80133 9.74416 5.09357 10.0927 6.29626 9.76959" fill="#BEE5F3"/>
				</svg>
			</div>
			<div class="font-light">TrueSelf  © 2025</div>
			<a href="/terms"> <span class="font-light">Terms</span></a>
			<a href="/privacy"> <span class="font-light">Privacy</span></a>
			<a href="mailto:support@trueself.io"> <span class="font-light">Contact</span></a>
		</div>
		<a href={null}>
			<span class="font-light">v{PUBLIC_VERSION}</span>
		</a>
		{#if showSettings} <a class="flex items-center gap-1.5 justify-end text-xs" href="/settings">
			<span class="font-light">Settings</span> 
			<img src={settingIcon} alt="Settings Icon" loading="lazy" />
		</a>
		{/if}
		
	</div>
	
 
	 
	<div class="absolute md:static left-1/2 -translate-x-1/2 md:translate-x-0 bottom-12">
		<a href={feedbackForm} target="_blank" class={`flex font-normal w-full whitespace-nowrap items-center justify-center text-xs leading-none text-center px-4 h-[30px] rounded-full duration-150 ring-1 ring-inset ring-white/50 bg-transparent hover:bg-white hover:text-primary text-white active:bg-white active:text-primary`}>
			Send Us Feedback
		</a>
	</div>  
	 
</footer>
